export default __webpack_public_path__ + "static/media/milky-way.5ae9a1f2.jpg";